module.exports = __webpack_public_path__ + "images/img-3r7zYR8.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/4.png
// module id = 2340
// module chunks = 0